import { Phone } from "lucide-react";

export default function FloatingCallButton() {
  return (
    <a
      href="tel:5599996208"
      data-testid="floating-call-button"
      className="fixed bottom-6 right-6 z-50 bg-green-600 hover:bg-green-700 text-white rounded-full p-4 shadow-2xl shadow-green-900/30 md:hidden transition-all duration-300 hover:scale-110 animate-glow-pulse"
      aria-label="Call Pete's Pool Service"
    >
      <Phone size={24} />
    </a>
  );
}
